export const CONTEXT_TYPE = {
    customerOfVisma: 'CustomerOfVisma',
    distributor: 'Distributor',
    visma: 'Visma',
    user: 'User',
    partner: 'Partner',
    customerOfCustomer: 'CustomerOfCustomer',
    company: 'Company',
    companyGroup: 'CompanyGroup'
}